export default class TypeFormatService {
  constructor() {}

  getFormatter(fieldSchema) {
    const getNumericSettings = (object) => {
      return { 
        allowNegative: true, 
        invertDelimeter: object.fmtInvertDelimiter, 
        decimalPlaces: object.fmtDecimalPlaces, 
        hasThousandsDelimiter: object.fmtHasThousandsDelimiter, 
        isIndianSystem: object.fmtIsIndianSystem,
        currencySymbol: object.fmtCurrencySymbol
      };
    };

    if (!fieldSchema?.numericFormats) return null;
    const settings = getNumericSettings(fieldSchema.numericFormats);
    return new Formatter(settings);
  }
}

class Formatter {
  constructor(settings) {
    this.settings = settings;
    this.decimalSeparator = settings.invertDelimeter ? ',' : '.';
    this.thousandsSeparator = settings.hasThousandsDelimiter ? (settings.invertDelimeter ? '.' : ',') : '';
    this.intPlaces = parseInt(settings.intPlaces, 10) || 21;
    this.decimalPlaces = parseInt(settings.decimalPlaces, 10);
    this.allowNegative = settings.allowNegative;
    this.currencySymbol = settings.currencySymbol;
    // Valid decimal number regex
    this.validNumberRegex = new RegExp(`^${(this.allowNegative ? '-?' : '')}\\d{0,${this.intPlaces}}\\${this.decimalSeparator}?\\d{0,${this.decimalPlaces}}$`);
    // Thousand separator regex
    this.numberSepRegex = /\B(?=(\d{3})+(?!\d))/g;
  }

  getIntegerFormat(intString) {
    if (this.settings.isIndianSystem)
      return (parseInt(intString) || 0).toLocaleString('en-IN').replace(/[,.]/g, this.thousandsSeparator);
    return intString.replace(this.numberSepRegex, this.thousandsSeparator);
  }

  removeThousandsSep(value) {
    return this.thousandsSeparator ? value.replace(new RegExp(`\\${ this.thousandsSeparator }`, 'g'), ''): value;
  } 

  formatFloat(value) {
    const numParts = value.split(this.decimalSeparator);
    const hasDecimalSep = !!numParts[1]?.length || value.endsWith(this.decimalSeparator);
    const numberWithSeparators = this.getIntegerFormat(numParts[0]).replace(/^0*/, '');
    const decimalSeparator = (this.decimalPlaces > 0) ? this.decimalSeparator : '';
    return `${numberWithSeparators || '0'}${hasDecimalSep ? `${decimalSeparator}${numParts[1]||''}`:''}`;
  }

  formatJsFloatStr(value) {
    let prevValue = this.formatFloat(value.toString().replace('.', this.decimalSeparator));
    if (!this.validNumberRegex.test(this.removeThousandsSep(prevValue))) prevValue = '';
    return prevValue;
  }

  formatFloatStr(value, prevValue, currSymbol = '', removeZeroDecimals = false) {
    let formattedValue = this.removeThousandsSep(value);
    if (!(this.allowNegative && formattedValue == '-') && !this.validNumberRegex.test(formattedValue)) formattedValue = this.removeThousandsSep(prevValue);
    if (formattedValue.startsWith('.')) formattedValue = `0${formattedValue}`;
    let frmtFloat = this.formatFloat(formattedValue);
    if (removeZeroDecimals) frmtFloat = this.removeTrailingDecimalZeros(frmtFloat);
    return `${currSymbol}${frmtFloat}`;
  }

  removeTrailingDecimalZeros(floatStr) {
    if (!floatStr.includes(this.decimalSeparator)) return floatStr;
    floatStr = floatStr.replace(/0+$/, "");
    if (floatStr[floatStr.length-1] == this.decimalSeparator) floatStr = floatStr.slice(0,-1);
    return floatStr;
  }

  formattedStrToFloat(strValue) {
    if (typeof strValue =='number') return strValue;
    const thousandSep = this.thousandsSeparator || ((this.decimalSeparator === ',') ? '.': ',');
    const jsFloatStr = strValue
      .replace(new RegExp(`\\${thousandSep}`, 'g'),'')
      .replace(new RegExp(`\\${this.decimalSeparator || '.'}`, 'g'),'.') || '0';
    const float = parseFloat(jsFloatStr);
    return isNaN(float) ? 0: float;
  }

  jsFloatToStr(floatValue = 0) {
    return floatValue.toFixed(this.decimalPlaces).toString()
      .replace('.', this.decimalSeparator);
  }

  getBehaviorValue(strValue) {
    if (strValue === undefined || strValue === null) return strValue;
    return this.formattedStrToFloat(strValue);
  }
};